import { ThemeProvider } from "@emotion/react";
import {
  createTheme,
  Dialog,
  DialogActions,
  DialogContent,
  Paper,
  PaperProps,
} from "@mui/material";
import { STheme } from "components/styles";
import Draggable from "react-draggable";
import { SDialogContext } from "states";

export type SDialogProps = {
  open: boolean;
  dialog: JSX.Element;
  action: JSX.Element;
  handleClose: Function;
  handleSubmit: Function;
};

export const SDialog = (props: SDialogProps): JSX.Element => {
  return (
    <ThemeProvider theme={theme}>
      <Dialog
        open={props.open}
        onClose={() => props.handleClose()}
        maxWidth={false}
        PaperComponent={PaperComponent}
      >
        <DialogContent>
          <SDialogContext.Provider value={props.handleSubmit}>
            {props.dialog}
          </SDialogContext.Provider>
        </DialogContent>
        <DialogActions>{props.action}</DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

const PaperComponent = (props: PaperProps) => (
  <Draggable handle=".handle">
    <Paper {...props} />
  </Draggable>
);

const theme = createTheme(
  {
    components: {
      MuiBackdrop: {
        styleOverrides: {
          root: {
            backgroundColor: STheme.modals.backdrop,
          },
        },
      },
    },
  },
  { ...STheme }
);
